import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { FullscreenExitSvg } from './FullscreenExit';

export const FullscreenExitIcon = createIcon('fullscreenExit', FullscreenExitSvg);
/**
 * @deprecated используйте FullscreenExitIcon
 */
export const withFullscreenExitIcon = withIcon('fullscreenExit', FullscreenExitSvg);
